<div class="card pt-2 pb-4">
<hr class="border-0">
  <div class="flex flex-row w-full">
    <div class="flex">
      <a [routerLink]="['/profile', comment.comment_user_name]">
        <img src="{{getAvatarImage()}}" appImgFallback='{{imageFallback}}' class="border-circle h-2rem" />
      </a>
    </div>
    <div class="flex flex-column pl-2 w-full">
      <a class="font-semibold" [routerLink]="['/profile', comment.comment_user_name]">{{ comment.comment_user_name }}</a>
      <div *ngIf="!comment.isEditing" class="comment-content" [innerHTML]="comment.comment_content"></div>
      <div *ngIf="comment.isEditing">
        <p-editor [(ngModel)]="comment.comment_content"
                  [style]="{'height':'50px'}">
          <ng-template pTemplate="header">
        <span class="ql-formats">
            <button type="button" class="ql-bold" aria-label="Bold"></button>
            <button type="button" class="ql-italic" aria-label="Italic"></button>
            <button type="button" class="ql-underline" aria-label="Underline"></button>
        </span>
          </ng-template>
        </p-editor>
        <div class="flex justify-content-end">
          <button pButton label="{{'comment_edit_btn' | translate}}"
                  type="button"
                  class="p-button-raised mt-2 mb-2 flex-grow-1 md:flex-grow-0"
                  (click)="commentEdited()"
                  [disabled]="isSubmitting">
          </button>
        </div>
      </div>
      <div class="flex flex-row align-items-center align-content-center justify-content-between text-500">
        <i class="pi pi-clock mr-2"></i>
        <span class="flex-grow-1">{{ comment.comment_date | dateperiod }}</span>
        <span [hidden]="!canModify"> <i class="pi pi-pencil cursor-pointer" (click)="editClicked()"></i> </span>&nbsp;
        <span [hidden]="!canModify"> <i class="pi pi-trash cursor-pointer" (click)="deleteClicked()"></i> </span>
      </div>
      </div>
  </div>
</div>
